import type { Allocation } from '@/entities/allocations/allocation.entity';
import { addHours, max, startOfHour } from 'date-fns';

export const getNewCarSwapDate = (allocations: Allocation[]) => {
  return max([
    startOfHour(addHours(new Date(), 2)),
    startOfHour(addHours(allocations[allocations.length - 1].startDate, 2)),
  ]);
};
